import React, { useState, useEffect } from 'react'
import Loader from '../../../presentationals/Loader/Loader.component'
import { getFiDetails, DownloadFIReport } from '../AdminActionCreator.component';
import Pagination from '@mui/material/Pagination';
import moment from 'moment';

const ItemsPerPage = 10;
export default function List({ handleType }) {
    const [payload, setPayload] = useState({
        sDate: moment().startOf("month").format("YYYY-MM-DD"),
        eDate: moment().format("YYYY-MM-DD")
    })
    const [searchText, setSearchText] = useState("")   // ← NEW
    const [loadarState, setloadarState] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [allUserDetail, setallUserDetail] = useState([]);
    const [totalItems, setTotalItems] = useState("")

    useEffect(() => {
        handleListAPi(currentPage)
    }, [])

    const handleListAPi = (page) => {
        setloadarState(true)
        const start = moment(payload?.sDate).format("DD-MM-YYYY")
        const end = moment(payload?.eDate).format("DD-MM-YYYY")
        getFiDetails(page, ItemsPerPage, start, end, searchText, callback => {   // ← searchText added
            setloadarState(false)
            setallUserDetail(callback?.data?.records)
            setTotalItems(callback?.data?.totalRecords)
        })
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        handleListAPi(value)
    };

    const handleInfo = (data) => {
        handleType("details", data)
    }

    const handleDownload = () => {
        setloadarState(true)
        const start = moment(payload?.sDate).format("DD-MM-YYYY")
        const end = moment(payload?.eDate).format("DD-MM-YYYY")
        DownloadFIReport(start, end, callback => {   // ← searchText added
            setloadarState(false)
        })
    }

    const handleDateChange = (e, type) => {
        const value = e.target.value;
        setPayload((prev) => ({ ...prev, [type]: value }));
    };

    const handleApply = () => {
        if (!payload.sDate || !payload.eDate) {
            alert("Please select both dates");
            return;
        }
        const start = moment(payload.sDate);
        const end = moment(payload.eDate);
        if (end.diff(start, "months", true) > 1) {
            alert("Date range cannot exceed 1 month");
            return;
        }
        handleListAPi(1);
        setCurrentPage(1);
    }

    return (
        <>
            <div className="container-fluid" style={{ padding: '0 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 className='blue-text'>Field Investigation</h3>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-2 col-xs-12">
                        <label>Start Date</label>
                        <input type='date' value={payload?.sDate} max={payload?.eDate}
                            onChange={(e) => handleDateChange(e, "sDate")} className='form-control' />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label>End Date</label>
                        <input type='date' value={payload?.eDate} min={payload?.sDate}
                            max={moment().format("YYYY-MM-DD")}
                            onChange={(e) => handleDateChange(e, "eDate")} className='form-control' />
                    </div>

                    {/* ───── NEW SEARCH FIELD ───── */}
                    <div className="col-sm-3 col-xs-12">
                        <label>Search</label>
                        <input
                            type='text'
                            className='form-control'
                            placeholder='Search by Customer Number'
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleApply()}
                        />
                    </div>
                    {/* ─────────────────────────── */}

                    <div className="col-sm-2 col-xs-12">
                        <div style={{ marginTop: '22px', display: 'flex', gap: '10px' }}>
                            <button className='btn btn-primary' style={{ padding: '10px' }} onClick={handleApply}>Apply</button>
                            <button className='btn btn-primary' style={{ padding: '10px' }} onClick={handleDownload}>
                                Download <i className='fa fa-download'></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-xs-12 no-padding overflow-auto">
                        {loadarState === false ?
                            allUserDetail != null && allUserDetail.length > 0 ?
                                <>
                                    <table className='phocket-table'>
                                        <thead>
                                            <tr>
                                                <td>Details</td>
                                                <td>CIF No.</td>
                                                <td>Customer Name</td>
                                                <td>Mobile No.</td>
                                                <td>FI Status</td>
                                                <td>Dealer Name</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allUserDetail?.map((data, i) => (
                                                <tr key={i}>
                                                    <td><i className='fa fa-info-circle' onClick={() => handleInfo(data)}></i></td>
                                                    <td>{data?.cifNo}</td>
                                                    <td>{data?.customerName}</td>
                                                    <td>{data?.phoneNo}</td>
                                                    <td className='light-dark-background'>
                                                        {data?.fiStatus?.charAt(0)?.toUpperCase() + data?.fiStatus?.slice(1)}
                                                    </td>
                                                    <td>{data?.dealerName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ float: 'right', marginTop: '15px' }}>
                                        <Pagination
                                            count={Math.ceil(totalItems / ItemsPerPage)}
                                            page={currentPage}
                                            onChange={handlePageChange}
                                            color="success"
                                        />
                                    </div>
                                </>
                                : "" :
                            <Loader />}
                    </div>
                </div>
            </div>
        </>
    )
}